<template>
    <main class="SectionPwa-MAIN">
        <section>

            <div class="pwa-blue">
                <!--<img src="../assets/ApArt-Logo-Black.png"/>-->
                <img src="../assets/pwa-ios.png" v-if="isIos"/>
                <img src="../assets/pwa-android.png" v-else/>
            </div>

            <div class="pwa-white">
                <h1>INSTALAR</h1>
                <hr/>
                <p>
                    Optimice su experiencia. Instale nuestro módulo en su dispositivo para disfrutar de navegación a pantalla completa, acceso inmediato y un mejor rendimiento.
                </p>
                <button @click="installPwa" :disabled="!canInstall" v-if="!isIos">AÑADIR A INICIO</button>
                <p v-if="isIos" class="ios-help">
                    En iPhone/iPad: toca Compartir → Agregar a pantalla de inicio.
                </p>
            </div>

        </section>
    </main>
</template>

<script>
export default {
    name: 'SectionPwa',
    data(){
        return{
            deferredPrompt: null,
            canInstall: false,
            isIos: false,
        }
    },
    mounted() {
        this.isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
        window.addEventListener('beforeinstallprompt', this.onBeforeInstallPrompt);
        window.addEventListener('appinstalled', this.onAppInstalled);
    },
    beforeUnmount() {
        window.removeEventListener('beforeinstallprompt', this.onBeforeInstallPrompt);
        window.removeEventListener('appinstalled', this.onAppInstalled);
    },
    methods: {

        onBeforeInstallPrompt(event) {
            event.preventDefault();
            this.deferredPrompt = event;
            this.canInstall = true;
        },

        async installPwa() {
            if (!this.deferredPrompt) return;
            this.deferredPrompt.prompt();
            const choice = await this.deferredPrompt.userChoice;
            console.log('Resultado instalación:', choice.outcome);
            this.deferredPrompt = null;
            this.canInstall = false;
        },

        onAppInstalled() {
            console.log('PWA instalada');
            this.deferredPrompt = null;
            this.canInstall = false;
        }

    }
}
</script>

<style scoped lang="stylus">
.SectionPwa-MAIN
    display: flex
    flex-direction: column
    padding: 10px
    width: calc(100% - 20px)
    min-height: calc(100vh - 20px)
    background-color: #dcdcdc

    >img
        width: 8vw
        margin-bottom: 2vw

    >section
        width: 100%
        height: calc(100vh - 20px)
        border-radius: 10px
        background-color: white
        overflow: hidden

/* blue */
.pwa-blue
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    height: fit-content
    background-color: rgb(1, 90, 255)

    >img
        width: 100%

/* white */
.pwa-white
    padding: 10px

    >h1
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        font-size: 12vw
        text-wrap: balance
        margin-bottom: 0

    >hr
        width: 100%
        border: 1px solid black

    >p
        font-family: "Archivo ExtraCondensed", sans-serif
        margin-top: 0
        font-size: 6vw
        color: #B0B0B0
        margin-bottom: 8vh

    >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace
        border: none

        &:disabled
            opacity: .45
</style>